export const timelineComponentMargin = 6;
export const transitionDurationInOut = 2;

export const minRangeAppearEnd = transitionDurationInOut; // minimum = transitionDurationInOut
